/** Framer Motion transition config for agent avatar: zooms in from above with fade. */
export const agentTransition = {
  hidden: { opacity: 0, y: -50, scale: 1.3 },
  show: { opacity: 1, y: 0, scale: 1, transition: { duration: 1.5 } },
  exit: { opacity: 0, y: 0, scale: 1.3, transition: { duration: 0.5 } },
} as const;

/** Framer Motion transition config for list items: zooms in from below with fade. */
export const itemTransition = {
  hidden: { opacity: 0, scale: 0.5, y: 50 },
  show: { opacity: 1, scale: 1, y: 0, transition: { duration: 1.5 } },
  exit: { opacity: 0, scale: 1.5, y: 0, transition: { duration: 0.5 } },
} as const;
